import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '@core/auth/auth-service/auth-service'

export const isAuthenticatedGuard: CanActivateFn = async () => {
  const router = inject(Router)
  const authService = inject(AuthService)

  if (!authService.currentUser()) {
    await authService.initialize()
  }

  if (!authService.isAuthenticated()) {
    router.navigate(['/login'])
    return false
  }

  return true
}
